import { TabModel } from '../interfaces/tab-model-interface';

export const CHAT_TABS: readonly TabModel[] = [
  {
    heading: 'Chat',
    icon: 'element-ai-message',
    closable: false,
    active: true
  }
] as const;
